import { z } from 'zod';
export const ADMISSION_CARE_ROLES = ['primary_consultant', 'co_consultant', 'resident'];
export const ADMISSION_SUPPORT_ROLES = ['co_consultant', 'resident'];
export const ADMISSION_CARE_TEAM_LIMIT = 12;
export const admissionCareTeamEntrySchema = z.object({
    userId: z.string().uuid(),
    role: z.enum(ADMISSION_SUPPORT_ROLES),
});
export const admitCareTeamSchema = z.array(admissionCareTeamEntrySchema).max(ADMISSION_CARE_TEAM_LIMIT - 1);
export const setPrimaryConsultantSchema = z.object({
    userId: z.string().uuid(),
    keepPrevious: z.boolean().default(true),
});
export const careTeamCandidatesQuerySchema = z.object({
    branchId: z.string().uuid().optional(),
    q: z.string().trim().max(80).optional(),
});
//# sourceMappingURL=admission-care-team.js.map